import { Container } from "pixi.js";
import type { GameTransitionPort } from "@slot/game-shell";

/**
 * The base ⇄ free-spins transition overlay. The title has nothing to play between the two (the trigger and finished
 * panels carry the moment), so the transition resolves at once; the shell's presenter still shows and hides the root
 * and fires its cue.
 */
export class GameTransitionView extends Container implements GameTransitionPort {
  public constructor() {
    super({ label: "GameTransitionPanel" });
    this.visible = false;
  }

  public show(): void {
    this.visible = true;
  }

  public hide(): void {
    this.visible = false;
  }

  public playTransition(): Promise<void> {
    return Promise.resolve();
  }
}
